import { memo } from 'react'
import Box from './Box'
import GrooverText from './GrooverText'
import { State } from '../hooks/useAppState'
import iconCompleted from '/public/iconCompleted.svg'
import useAppState from '../hooks/useAppState'

type Props = {
  state: State
  registerActiveStep: number
}

const CourseRegistrationStepThreeClosedContent = ({ registerActiveStep, state }: Props) => {
  const { state: appState } = useAppState()
  const language = appState.selectedLanguage

  return (
    <Box fullWidth direction="row" align="center" gap="15px">
      {registerActiveStep > 3 || state.isRegistrationCompleted || !!state.obfuscatedEnrollment?.mainUser ? (
        <img src={iconCompleted} width={24} height={24} />
      ) : null}
      <GrooverText textKey="registrationHeadersAndStatusHeaderSummaryAndApproval" language={language} />
    </Box>
  )
}

export default memo(CourseRegistrationStepThreeClosedContent)
